import { Grid } from "@mui/material";
import { useContext, useEffect } from "react";
import isEmpty from "../../../../common/helpers/isEmpty";
import OrderFormShortBundlingContainer from "./OrderFormShortBundlingContainer";
import OrderFormShortRowFields from "./OrderFormShortRowFields";
import { ShiftOrderContext } from "./OrderShortDataProvider";
import OrderFormShortAdditionalInfo from "../../additionalInfo/OrderFormShortAdditionalInfo";
import { findOverlappingOrders } from "./orderFormShortRowHandlers";

const OrderFormShortRow = () => {
  const { orderRows, setValidationErrors } = useContext(ShiftOrderContext);

  useEffect(() => {
    const bundleRows = orderRows.filter((row) => row.bundleId);
    const extendedOrderFields = !isEmpty(bundleRows)
      ? bundleRows.flatMap((row) =>
          row.rows.map((item) => ({
            ...item,
            bundleId: row.bundleId as string,
          })),
        )
      : null;

    if (extendedOrderFields) {
      const overlappingOrderRows = findOverlappingOrders(extendedOrderFields);

      // override overlapping shift validation errors, keep other errors
      setValidationErrors((prevErrors) => {
        const otherValidationErrors = prevErrors.filter(
          (error) => error.errorType !== "overlappingTimes",
        );
        return [...otherValidationErrors, ...overlappingOrderRows];
      });
    }
  }, [orderRows, setValidationErrors]);

  return (
    <Grid container item spacing={1} alignItems="center">
      {!!orderRows.length &&
        orderRows
          .sort((a, b) => a.createdAt - b.createdAt)
          .map((row, index) => (
            <Grid
              key={row.rowId}
              container
              item
              spacing={1}
              alignItems="flex-start"
              wrap="nowrap"
            >
              {!row.bundleId ? (
                <OrderFormShortRowFields
                  key={row.rowId}
                  rowId={row.rowId}
                  values={row.rows[0]}
                  isFirstRow={index === 0}
                />
              ) : (
                <OrderFormShortBundlingContainer
                  row={row}
                  bundleRowId={row.bundleId as string}
                />
              )}
              <OrderFormShortAdditionalInfo
                row={row}
                bundleRowId={row.bundleId}
              />
            </Grid>
          ))}
    </Grid>
  );
};

export default OrderFormShortRow;
